<template>
  <div>
    <div class="main-content" v-if="advance">
      <div class="row">
        <div class="col-md-12">
          <div class="card p-1 pb-2">
            <div class="d-flex align-items-center justify-content-between flex-wrap">
              <h5 class="mb-0">Adiantamento #{{ advance.id }}</h5>
              <div>
                <span v-if="advance.is_contested" class="badge badge-warning mr-50" style="font-size: 14px">CONTESTADO</span>
                <span :class="['badge', status.badge]" style="font-size: 14px">{{ status.text }}</span>
              </div>
            </div>

            <div class="col-12 mt-2" v-if="advance.is_contested">
              <contest-banner :items="items" :reviewing="isReviewing" />
            </div>

            <!-- Dados da solicitação -->
            <div class="col-12 mt-3 mb-2">
              <div :class="cardClass">
                <div class="advance-card-header">
                  <i class="fas fa-money-bill-wave text-success" style="font-size: 22px"></i>
                  <h3 class="mb-0 text-success advance-card-title">Dados do Adiantamento</h3>
                  <div class="advance-card-line" style="border-color: #28a745"></div>
                </div>

                <div class="row">
                  <div class="col-md-4 mb-1">
                    <label :class="labelClass">Colaborador</label>
                    <div>{{ advance.user ? advance.user.name : "-" }}</div>
                  </div>
                  <div class="col-md-3 mb-1">
                    <label :class="labelClass">Valor do adiantamento</label>
                    <div>{{ formatCurrency(advance.advance_amount) }}</div>
                  </div>
                  <div class="col-md-2 mb-1">
                    <label :class="labelClass">Tipo</label>
                    <div>
                      <span v-if="isDinner" class="badge badge-info">Jantar</span>
                      <span v-else class="badge badge-secondary">Normal</span>
                    </div>
                  </div>
                  <div class="col-md-3 mb-1">
                    <label :class="labelClass">Data da solicitação</label>
                    <div>{{ advance.date_f }}</div>
                  </div>
                  <div class="col-md-12 mt-1">
                    <label :class="labelClass">Justificativa</label>
                    <div style="white-space: pre-line">{{ advance.justification || "-" }}</div>
                  </div>
                  <div class="col-md-12 mt-1" v-if="Number(advance.approve) === STATUS.REJECTED && advance.observation">
                    <label :class="labelClass">Motivo da rejeição</label>
                    <div class="text-danger" style="white-space: pre-line">{{ advance.observation }}</div>
                  </div>
                  <div class="col-md-12 mt-1" v-if="advance.deposit_receipt">
                    <label :class="labelClass">Comprovante de depósito do adiantamento</label>
                    <a href="#" @click.prevent="download('deposit_receipt', advance.deposit_receipt)">
                      <i class="fas fa-download"></i> {{ advance.deposit_receipt }}
                    </a>
                  </div>
                  <div class="col-md-12 mt-1" v-if="advance.receipt && showSettlementReceipt">
                    <label :class="labelClass">Comprovante de acerto</label>
                    <a href="#" @click.prevent="download('settlement_receipt', advance.receipt)">
                      <i class="fas fa-download"></i> {{ advance.receipt }}
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <!-- Etapa 0: aprovação da solicitação -->
            <div class="col-12 mb-2" v-if="Number(advance.approve) === STATUS.WAITING_APPROVAL && can.manage">
              <div :class="cardClass">
                <div class="advance-card-header">
                  <i class="fas fa-user-check text-primary" style="font-size: 22px"></i>
                  <h3 class="mb-0 text-primary advance-card-title">Aprovação da Solicitação</h3>
                  <div class="advance-card-line" style="border-color: #007bff"></div>
                </div>
                <div v-if="rejectingRequest" class="mb-1">
                  <label :class="labelClass"><span class="required">*</span> Motivo da rejeição</label>
                  <textarea v-model="rejectReason" :class="['form-control', inputClass]" rows="3"></textarea>
                </div>
                <div class="text-right">
                  <template v-if="!rejectingRequest">
                    <button class="btn btn-danger mr-1" @click="rejectingRequest = true">
                      <i class="fas fa-ban"></i> Rejeitar
                    </button>
                    <button class="btn btn-success" @click="approveRequest">
                      <i class="fas fa-check"></i> Aprovar
                    </button>
                  </template>
                  <template v-else>
                    <button class="btn btn-secondary mr-1" @click="rejectingRequest = false">Cancelar</button>
                    <button class="btn btn-danger" @click="rejectRequest">Confirmar rejeição</button>
                  </template>
                </div>
              </div>
            </div>

            <!-- Etapa 6: depósito do adiantamento (RH) -->
            <div class="col-12 mb-2" v-if="Number(advance.approve) === STATUS.WAITING_DEPOSIT && can.deposit">
              <div :class="cardClass">
                <div class="advance-card-header">
                  <i class="fas fa-university text-warning" style="font-size: 22px"></i>
                  <h3 class="mb-0 text-warning advance-card-title">Comprovante de Depósito</h3>
                  <div class="advance-card-line" style="border-color: #ff9f43"></div>
                </div>
                <p class="mb-1">
                  Anexe o comprovante do depósito do adiantamento para o colaborador.
                  <span v-if="isDinner">Por ser adiantamento de jantar, o processo será finalizado.</span>
                  <span v-else>Em seguida o colaborador fará a prestação de contas.</span>
                </p>
                <div class="d-flex align-items-center flex-wrap">
                  <input ref="depositFile" type="file" accept=".jpg,.jpeg,.png,.pdf" :class="['form-control', inputClass]" style="max-width: 420px" />
                  <button class="btn btn-success ml-1" @click="uploadReceipt('deposit_receipt', 'depositFile')">
                    <i class="fas fa-upload"></i> Anexar comprovante
                  </button>
                </div>
              </div>
            </div>

            <!-- Etapa 4: aviso para o colaborador -->
            <div class="col-12 mb-2" v-if="Number(advance.approve) === STATUS.WAITING_ACCOUNTABILITY && can.fill">
              <div class="alert alert-warning p-1 mb-0 d-flex align-items-center justify-content-between flex-wrap">
                <span>O adiantamento foi depositado. Lance suas despesas com os comprovantes e envie a prestação de contas.</span>
                <router-link :to="`/reimbursement_solicitations/edit/${advance.id}`" class="btn btn-warning btn-sm">
                  <i class="fas fa-receipt"></i> Preencher despesas
                </router-link>
              </div>
            </div>

            <!-- Despesas da prestação de contas -->
            <div class="col-12 mb-2" v-if="!isDinner && items.length">
              <expense-review-table
                :items="items"
                :reviewing="isReviewing"
                :can-contest="can.contest"
                @decide="decide"
                @save-amount="saveAmount"
                @contest="contest"
              />
            </div>

            <!-- Resumo financeiro -->
            <div class="col-12 mb-2" v-if="!isDinner && hasAccountability">
              <financial-summary
                mode="advance"
                :totals="totals"
                :reviewing="isReviewing"
                :in-review="Number(advance.approve) === STATUS.ACCOUNTABILITY_REVIEW"
                @conclude="conclude"
              />
            </div>

            <!-- Etapa 3: comprovante de acerto -->
            <div class="col-12 mb-2" v-if="Number(advance.approve) === STATUS.WAITING_RECEIPT">
              <div :class="cardClass">
                <div class="advance-card-header">
                  <i class="fas fa-file-invoice-dollar text-warning" style="font-size: 22px"></i>
                  <h3 class="mb-0 text-warning advance-card-title">Comprovante de Acerto</h3>
                  <div class="advance-card-line" style="border-color: #ff9f43"></div>
                </div>
                <p class="mb-1" v-if="totals.balance_to_receive < 0">
                  A IT4D deve reembolsar {{ formatCurrency(Math.abs(totals.balance_to_receive)) }} ao colaborador.
                  O Administrador RH deve anexar o comprovante de reembolso.
                </p>
                <p class="mb-1" v-else>
                  O colaborador deve devolver {{ formatCurrency(totals.balance_to_receive) }} à IT4D
                  e anexar o comprovante de devolução.
                </p>
                <div v-if="lastReturnRejection" class="alert alert-danger p-1 mb-1">
                  <strong>Comprovante anterior recusado.</strong> {{ lastReturnRejection }}
                </div>
                <div class="d-flex align-items-center flex-wrap" v-if="can.settlement_receipt">
                  <input ref="settlementFile" type="file" accept=".jpg,.jpeg,.png,.pdf" :class="['form-control', inputClass]" style="max-width: 420px" />
                  <button class="btn btn-success ml-1" @click="uploadReceipt('settlement_receipt', 'settlementFile')">
                    <i class="fas fa-upload"></i> Anexar comprovante
                  </button>
                </div>
              </div>
            </div>

            <!-- Etapa 8: validação da devolução pelo gestor -->
            <div class="col-12 mb-2" v-if="Number(advance.approve) === STATUS.WAITING_RETURN_VALIDATION">
              <div :class="cardClass">
                <div class="advance-card-header">
                  <i class="fas fa-search-dollar text-warning" style="font-size: 22px"></i>
                  <h3 class="mb-0 text-warning advance-card-title">Validação da Devolução</h3>
                  <div class="advance-card-line" style="border-color: #ff9f43"></div>
                </div>
                <p class="mb-1">
                  O colaborador anexou o comprovante de devolução de {{ formatCurrency(totals.balance_to_receive) }} à IT4D.
                  <span v-if="can.validate_return">Confira se o depósito foi realmente recebido antes de finalizar.</span>
                  <span v-else>Aguardando a validação do Administrador RH ou Geral.</span>
                </p>
                <div class="mb-1">
                  <a href="#" @click.prevent="download('settlement_receipt', advance.receipt)">
                    <i class="fas fa-download"></i> {{ advance.receipt }}
                  </a>
                </div>
                <template v-if="can.validate_return">
                  <div v-if="rejectingReturn" class="mb-1">
                    <label :class="labelClass"><span class="required">*</span> Motivo da recusa do comprovante</label>
                    <textarea v-model="rejectReturnReason" :class="['form-control', inputClass]" rows="3"></textarea>
                  </div>
                  <div class="text-right">
                    <template v-if="!rejectingReturn">
                      <button class="btn btn-danger mr-1" @click="rejectingReturn = true">
                        <i class="fas fa-ban"></i> Recusar comprovante
                      </button>
                      <button class="btn btn-success" @click="validateReturn">
                        <i class="fas fa-check-double"></i> Confirmar devolução
                      </button>
                    </template>
                    <template v-else>
                      <button class="btn btn-secondary mr-1" @click="rejectingReturn = false">Cancelar</button>
                      <button class="btn btn-danger" @click="rejectReturn">Confirmar recusa</button>
                    </template>
                  </div>
                </template>
              </div>
            </div>

            <!-- Histórico -->
            <div class="col-12 mb-2" v-if="history.length">
              <div :class="cardClass">
                <div class="advance-card-header">
                  <i class="fas fa-history text-secondary" style="font-size: 22px"></i>
                  <h3 class="mb-0 text-secondary advance-card-title">Histórico</h3>
                  <div class="advance-card-line" style="border-color: #6c757d"></div>
                </div>
                <ul class="list-unstyled mb-0">
                  <li v-for="h in history" :key="h.id" class="mb-50">
                    <strong>{{ formatDateTime(h.created_at) }}</strong>
                    <span v-if="h.user"> - {{ h.user.name }}</span>:
                    {{ h.message }}
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-md-12">
              <div class="block text-right mb-1">
                <router-link to="/advances" class="btn btn-back">
                  <i class="fa fa-arrow-left"></i> Voltar
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ADVANCE_STATUS, advanceStatusBadge } from "../../utils/expenseStatus";
import ExpenseReviewTable from "../../components/Expenses/ExpenseReviewTable.vue";
import FinancialSummary from "../../components/Expenses/FinancialSummary.vue";
import ContestBanner from "../../components/Expenses/ContestBanner.vue";

export default {
  components: { ExpenseReviewTable, FinancialSummary, ContestBanner },
  data() {
    return {
      STATUS: ADVANCE_STATUS,
      advance: null,
      totals: { advance_amount: 0, total_expenses: 0, total_approved: 0, balance_to_receive: 0, pending_items: 0 },
      can: { manage: false, deposit: false, fill: false, settlement_receipt: false, validate_return: false, contest: false },
      rejectingReturn: false,
      rejectReturnReason: "",
      rejectingRequest: false,
      rejectReason: "",
    };
  },
  computed: {
    dark() {
      return this.$store.state.appConfig.layout.skin === "dark";
    },
    cardClass() {
      return ["advance-card", this.dark ? "advance-card-dark" : "advance-card-light"];
    },
    labelClass() {
      return this.dark ? "advance-label-dark" : "advance-label-light";
    },
    inputClass() {
      return this.dark ? "advance-input-dark" : "advance-input-light";
    },
    status() {
      return advanceStatusBadge(this.advance.approve, this.advance.accountability_result);
    },
    isDinner() {
      return Boolean(Number(this.advance.is_dinner_advance));
    },
    items() {
      return this.advance.reimbursements || [];
    },
    history() {
      return this.advance.approval_history || [];
    },
    showSettlementReceipt() {
      return !this.isDinner && Number(this.advance.approve) === ADVANCE_STATUS.FINISHED;
    },
    lastReturnRejection() {
      // Recusa mais recente do comprovante de devolução (etapa 8 -> 3)
      const last = [...this.history].reverse().find((h) => Number(h.status_old) === ADVANCE_STATUS.WAITING_RETURN_VALIDATION);
      if (!last || Number(last.status_new) !== ADVANCE_STATUS.WAITING_RECEIPT) return null;
      return last.message.replace(/^Comprovante de devolução recusado:\s*/, "Motivo: ");
    },
    isReviewing() {
      return Number(this.advance.approve) === ADVANCE_STATUS.ACCOUNTABILITY_REVIEW && this.can.manage;
    },
    hasAccountability() {
      return [
        ADVANCE_STATUS.ACCOUNTABILITY_REVIEW,
        ADVANCE_STATUS.WAITING_RECEIPT,
        ADVANCE_STATUS.WAITING_RETURN_VALIDATION,
        ADVANCE_STATUS.FINISHED,
      ].includes(
        Number(this.advance.approve)
      ) && this.items.length > 0;
    },
  },
  methods: {
    apiUrl(path = "") {
      return this.$store.state.api + "advances/" + this.$route.params.id + (path ? "/" + path : "");
    },
    applyResponse(response) {
      this.advance = response.data.data;
      this.totals = response.data.totals;
      if (response.data.can) {
        this.can = response.data.can;
      }
    },
    errorMessage(error, fallback) {
      const data = error.response && error.response.data;
      if (data && data.errors) {
        return Object.values(data.errors)[0][0];
      }
      return (data && data.message) || fallback;
    },
    async load() {
      try {
        this.$loading(true);
        this.applyResponse(await axios.get(this.apiUrl("detail")));
      } catch (error) {
        this.$message(null, this.errorMessage(error, "Erro ao carregar o adiantamento"), "error");
        this.$router.push("/advances");
      } finally {
        this.$loading(false);
      }
    },
    async run(request, fallback) {
      try {
        this.$loading(true);
        const response = await request();
        // A resposta das ações não traz as permissões; recarrega para atualizá-las
        const detail = await axios.get(this.apiUrl("detail"));
        this.applyResponse(detail);
        if (response.data.message) {
          this.$message("Sucesso", response.data.message, "success");
        }
        return true;
      } catch (error) {
        this.$message(null, this.errorMessage(error, fallback), "error");
        return false;
      } finally {
        this.$loading(false);
      }
    },
    approveRequest() {
      this.run(() => axios.post(this.apiUrl("approve")), "Erro ao aprovar o adiantamento");
    },
    async rejectRequest() {
      if (!this.rejectReason.trim()) {
        this.$message(null, "Informe o motivo da rejeição", "error");
        return;
      }
      const ok = await this.run(
        () => axios.post(this.apiUrl("reject"), { reason: this.rejectReason.trim() }),
        "Erro ao rejeitar o adiantamento"
      );
      if (ok) {
        this.rejectingRequest = false;
        this.rejectReason = "";
      }
    },
    validateReturn() {
      const self = this;
      swal({
        title: "Confirmar devolução?",
        text: "Confirme apenas se o depósito da devolução foi recebido pela IT4D. O processo será finalizado.",
        icon: "warning",
        buttons: {
          cancel: { text: "Cancelar", value: false, visible: true, className: "btn-secondary" },
          confirm: { text: "Confirmar", value: true, className: "btn-success" },
        },
      }).then((confirmed) => {
        if (confirmed) {
          self.run(() => axios.post(self.apiUrl("validate_return")), "Erro ao validar a devolução");
        }
      });
    },
    async rejectReturn() {
      if (!this.rejectReturnReason.trim()) {
        this.$message(null, "Informe o motivo da recusa do comprovante", "error");
        return;
      }
      const ok = await this.run(
        () => axios.post(this.apiUrl("reject_return"), { reason: this.rejectReturnReason.trim() }),
        "Erro ao recusar o comprovante"
      );
      if (ok) {
        this.rejectingReturn = false;
        this.rejectReturnReason = "";
      }
    },
    async uploadReceipt(path, ref) {
      const input = this.$refs[ref];
      const file = input && input.files && input.files[0];
      if (!file) {
        this.$message(null, "Selecione o comprovante", "error");
        return;
      }
      const fd = new FormData();
      fd.append("file", file);
      const ok = await this.run(() => axios.post(this.apiUrl(path), fd), "Erro ao anexar o comprovante");
      if (ok && this.$refs[ref]) {
        this.$refs[ref].value = "";
      }
    },
    async download(path, fileName) {
      try {
        const response = await axios.get(this.apiUrl(path), { responseType: "blob" });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.$message(null, "Não foi possível baixar o comprovante", "error");
      }
    },
    // Decisão e edição de valor vêm do componente de despesas; o backend recalcula e devolve os totais
    async decide({ item, approve, observation, done }) {
      try {
        this.$loading(true);
        this.applyResponse(await axios.post(this.apiUrl(`items/${item.id}/decision`), { approve, observation }));
        done();
      } catch (error) {
        this.$message(null, this.errorMessage(error, "Erro ao registrar a decisão"), "error");
      } finally {
        this.$loading(false);
      }
    },
    async saveAmount({ item, amount, done }) {
      try {
        this.$loading(true);
        this.applyResponse(await axios.put(this.apiUrl(`items/${item.id}/amount`), { amount }));
        done();
      } catch (error) {
        this.$message(null, this.errorMessage(error, "Erro ao alterar o valor"), "error");
      } finally {
        this.$loading(false);
      }
    },
    async contest({ item, justification, done }) {
      const ok = await this.run(
        () => axios.post(this.apiUrl(`items/${item.id}/contest`), { justification }),
        "Erro ao enviar a contestação"
      );
      if (ok) done();
    },
    conclude() {
      const self = this;
      swal({
        title: "Concluir análise?",
        text: "Após concluir, as decisões e valores das despesas não poderão mais ser alterados.",
        icon: "warning",
        buttons: {
          cancel: { text: "Cancelar", value: false, visible: true, className: "btn-secondary" },
          confirm: { text: "Concluir", value: true, className: "btn-primary" },
        },
      }).then((confirmed) => {
        if (confirmed) {
          self.run(() => axios.post(self.apiUrl("conclude")), "Erro ao concluir a análise");
        }
      });
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(value) || 0);
    },
    formatDateTime(value) {
      if (!value) return "";
      const d = new Date(value);
      return isNaN(d) ? value : d.toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style scoped>
.required {
  color: #ea5455;
}

.advance-card {
  border-radius: 12px;
  padding: 24px 18px;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.advance-card-dark {
  background: #191e2e;
  border: 1px solid #4a5568;
}

.advance-card-light {
  background: #f8f8fa;
  border: 1px solid #e2e6ea;
}

.advance-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
}

.advance-card-title {
  font-weight: 700;
}

.advance-card-line {
  flex: 1;
  border-bottom: 4px solid;
  margin-left: 16px;
  opacity: 0.6;
}

.advance-label-dark {
  color: #a0aec0;
  font-weight: 500;
  margin-bottom: 0.25rem;
  display: block;
}

.advance-label-light {
  color: #6e6b7b;
  font-weight: 500;
  margin-bottom: 0.25rem;
  display: block;
}

.advance-input-dark {
  background: #2d3748;
  border: 1px solid #4a5568;
  color: #e2e8f0;
}

.advance-input-light {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  color: #2d3748;
}
</style>
